import { Injectable, inject } from '@angular/core';
import { CanMatch, Route, UrlSegment, Router, UrlTree } from '@angular/router';
import { BaseRolesService } from '../services/base-roles.service';
import { BaseTokenService } from '../services/base-token.service';

@Injectable({ providedIn: 'root' })
export class BaseAuthorisedUserGuard implements CanMatch {
  private router = inject(Router);
  private rolesService = inject(BaseRolesService);
  private tokenService = inject(BaseTokenService);

  canMatch(_: Route, segments: UrlSegment[]): boolean | UrlTree {
    const isLoginRoute = segments.length > 1 && segments[0].path === 'auth' && segments[1].path === 'login';
    return this.checkRouteAccess(isLoginRoute);
  }

  private checkRouteAccess(isLoginRoute: boolean): boolean | UrlTree {
    const loggedIn = this.tokenService.isAuthenticated();

    const nav = this.router.getCurrentNavigation?.();
    const fromLogout = nav?.extras?.state?.['fromLogout'] ?? window.history.state?.['fromLogout'];

    if (isLoginRoute) {
      if (loggedIn && !fromLogout) {
        return this.router.parseUrl(this.getTargetForLoggedInUser());
      }

      return true;
    }

    if (!loggedIn) {
      return true;
    }

    return this.router.parseUrl(this.getTargetForLoggedInUser());
  }

  private getTargetForLoggedInUser(): string {
    return this.rolesService.hasWorkCouncilRole() ? '/offers' : '/dashboard';
  }
}
